import { HandleSearchSubmitType } from "@website/accommodation-ui/villa-search/villa-search-panel/villa-search-panel.types";
import { VillaCityDataType } from "@website/accommodation-ui/villa-search/villa-search.types";
import { USER_TRACKING_EVENTS } from "@website/tracking/tracking.types";
import { addEventToTracking } from "@website/tracking/user";
import { DatepickerSelectedDateType } from "@website/ui/datepicker";
import { daysBetweenDates } from "@website/utils/date-format";
import { useCallback, useState } from "react";

export const useSubmit = (
  selectedDestinationItem: any,
  date: DatepickerSelectedDateType,
  passengerNumber: { adult: number; child: number; room: number },
  addToHistory: (
    destination: any,
    startDate: any,
    endDate: any,
    passengerNumber: any
  ) => void,
  submitValidationCheck: () => boolean,
  handleSearchSubmit?: HandleSearchSubmitType,
  initialDestinationItem?: VillaCityDataType
) => {
  const [submitLoading, setSubmitLoading] = useState<boolean>(false);
  const onSubmitClick = useCallback(async () => {
    setSubmitLoading(true);
    if (submitValidationCheck()) {
      const startDate = date[0]?.dateTime;
      const endDate = date[1]?.dateTime;
      const destinationItem = selectedDestinationItem || initialDestinationItem;
      if (!startDate && !endDate) return;
      if (destinationItem) {
        addToHistory(destinationItem, startDate, endDate, passengerNumber);
        await handleSearchSubmit?.(
          destinationItem.url,
          startDate,
          endDate,
          `${passengerNumber.adult}`,
          `${passengerNumber.child}`,
          `${passengerNumber.room}`,
          destinationItem.type,
          initialDestinationItem?.id,
          destinationItem.title,
          destinationItem.location?.latitude,
          destinationItem.location?.longitude
        );

        const trackingPayload = {
          stay_duration_days: daysBetweenDates(startDate, endDate)
        };

        addEventToTracking(USER_TRACKING_EVENTS.DATE_SELECTED, {
          product: "villa",
          ...trackingPayload
        });
        setSubmitLoading(false);
      } else {
        setSubmitLoading(false);
      }
    } else {
      setSubmitLoading(false);
    }
  }, [
    submitValidationCheck,
    date,
    selectedDestinationItem,
    initialDestinationItem,
    addToHistory,
    passengerNumber,
    handleSearchSubmit
  ]);

  return { onSubmitClick, submitLoading };
};
